import OnboardingWizard from "../client_onboarding/OnboardingWizard";
import ClientLandingPage from "../client_landing/ClientLandingPage";
import { AuthContext } from "../contexts/AuthContext";
import { useContext } from "react";

export default function ClientOnboardingEntry() {
  const { onboardingCompleted, loading, user_data } = useContext(AuthContext);

  if (loading) return null;
  if (onboardingCompleted === true) return <ClientLandingPage />;
  return <OnboardingWizard clientId={user_data.client_unique_account_id} />;
}
